import { RouteRecordRaw, RouterView } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "quickReply",
    name: "quickReply",
    component: () => import("@/views/quick-reply/index.vue")
  }
];
export default routes;